import { Country } from '@staycool/location';
import { Currency } from '../wallet/types';

export enum PROVIDERS {
    ALPS_BANK = 'alps-bank',
    ASTROPAY = 'astropay',
    AUTHIPAY_AIBMS_CARD = 'authipay-aibms-card',
    BLIXTPAY = 'blixtpay',
    BRAINTREE_PAYPAL = 'braintree-paypal',
    CARD_EYE = 'card-eye',
    CLEO = 'cleo',
    COOLPAY = 'coolpay',
    COOLPAY_CARD = 'coolpay-card',
    CASH_AT_CAGE = 'cash-at-cage',
    DEVCODE_BAMBORA = 'devcode-bambora',
    DEVCODE_CLEANPAY = 'devcode-cleanpay',
    DEVCODE_ECOPAYZ = 'devcode-ecopayz',
    DEVCODE_INTERAC_COMBINED = 'devcode-interac-combined',
    DEVCODE_INTERAC_E_CASHOUT = 'devcode-interac-e-cashout',
    DEVCODE_INTERAC_E_TRANSFER = 'devcode-interac-e-transfer',
    DEVCODE_INTERAC_ONLINE = 'devcode-interac-online',
    DEVCODE_JETON_WALLET = 'devcode-jeton-wallet',
    DEVCODE_KLUWP_MASTERCARD = 'devcode-kluwp-mastercard',
    DEVCODE_KLUWP_VISA = 'devcode-kluwp-visa',
    DEVCODE_MUCHBETTER = 'devcode-muchbetter',
    DEVCODE_NEOSURF_VOUCHER = 'devcode-neosurf-voucher',
    DEVCODE_SECURE_TRADING = 'devcode-secure-trading',
    DIRECTA24_BANK = 'directa24-bank',
    DIRECTA24_VOUCHERS = 'directa24-vouchers',
    EPRO_CASHLIB = 'epro-cashlib',
    EPRO_EASYWIRE = 'epro-easywire',
    EPRO_KWICK_N_GO = 'epro-kwick-n-go',
    EPRO_PASS_N_GO = 'epro-pass-n-go',
    EUTELLER = 'euteller',
    EVERY_PAY_APPLE_PAY = 'every-pay-apple-pay',
    EVERY_PAY_GOOGLE_PAY = 'every-pay-google-pay',
    GLOBALPAY = 'globalpay',
    IN_APP_PURCHASE = 'in-app-purchase',
    IN_APP_PURCHASE_ANDROID = 'in-app-purchase-android',
    IN_APP_PURCHASE_IOS = 'in-app-purchase-ios',
    INTERAC_COMBINED = 'interac-combined',
    INTERAC_E_CASHOUT = 'interac-e-cashout',
    INTERAC_E_TRANSFER = 'interac-e-transfer',
    JETON_LOCAL = 'jeton-local',
    LHV = 'lhv',
    LUQAPAY_COMMUNITY_BANK = 'luqapay-community-bank',
    LUQAPAY_JETON = 'luqapay-jeton',
    LUQAPAY_VOUCHER_CARD = 'luqapay-voucher-card',
    MONNET_BANK = 'monnet-bank',
    NEOPAY_BANK = 'neopay-bank',
    NETELLER = 'neteller',
    NUVEI_APPLE_PAY = 'nuvei-apple-pay',
    NUVEI_CARD = 'nuvei-card',
    PAYHOUND_BITCOIN = 'payhound-bitcoin',
    PAYHOUND_USDT = 'payhound-usdt',
    PAYHOUND_USDC = 'payhound-usdc',
    PAY_NEAR_ME_DEBIT_CARD = 'pay-near-me-debit-card',
    PAY_NEAR_ME_CREDIT_CARD = 'pay-near-me-credit-card',
    PAY_NEAR_ME_VENMO = 'pay-near-me-venmo',
    PAY_NEAR_ME_VOUCHER = 'pay-near-me-voucher',
    PAY_NEAR_ME_PAYPAL = 'pay-near-me-paypal',
    PAY_NEAR_ME_APPLE_PAY = 'pay-near-me-apple-pay',
    PAYORO = 'payoro',
    PAYPAL = 'paypal',
    PRONTO_PAGA_BANK = 'pronto-paga-bank',
    PRONTO_PAGA_PAYPHONE = 'pronto-paga-payphone',
    RIDDEC_BANK = 'riddec-bank',
    SEB = 'seb',
    SEPA = 'sepa',
    SEPA_B9S = 'sepa-b9s',
    SEPA_G4E = 'sepa-g4e',
    SHIFT4_CARD = 'shift4-card',
    SIGHTLINE = 'sightline',
    SIGHTLINE_V2 = 'sightline-v2',
    SKRILL = 'skrill',
    TRUELAYER = 'truelayer',
    TRUSTLY = 'trustly',
    TRUSTLY_SWISH = 'trustly-swish',
    TRUSTLY_US = 'trustly-us',
    TRUSTLY_US_SILVER = 'trustly-us-silver',
    WORLDPAY = 'worldpay',
}

export enum PROVIDER_TYPE {
    DEPOSIT = 'DEPOSIT',
    WITHDRAWAL = 'WITHDRAWAL',
}

export type PaymentProvider = {
    aux: any;
    disclaimer: string;
    feeDays: number;
    feePercent: number;
    hideAmountSelector?: boolean;
    id: number;
    image: string;
    isDepositRequired: boolean;
    isDisabled: boolean;
    isFeeRequired: boolean;
    isShowingPaymentMethods: boolean;
    isQuickDepositEnabled: boolean;
    isDailyPayoutLimitProviderExceeded: boolean;
    isDailyPayoutLimitGlobalExceeded: boolean;
    kycRestriction: PaymentProviderKycRestriction;
    maxAmount: any;
    minAmount: any;
    order: number;
    slug: PROVIDERS;
    time: string;
    title: string;
    type: PROVIDER_TYPE;
};

export const enum PaymentProviderKycRestriction {
    ASK_ID_VERIFICATION_ON_PAYMENT = 'Ask ID verification on payment',
}

export type Transaction = {
    id: string;
    state: TransactionState;
    type: TransactionType;
    walletTransactionId: string;
    cancelWithdrawalLock?: {
        hasCancelWithdrawalLock: boolean;
    };
    currency: Currency;
    user_id: string;
    external_transaction_id: string;
    created: string;
    description: string;
    gameName?: string;
    product: string;
    provider: PROVIDERS;
    amountUc: number;
    balance_uc: number;
};

export enum TransactionState {
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
    PAYOUT_FAILED = 'PAYOUT_FAILED',
}

export enum TransactionType {
    DEPOSIT = 'DEPOSIT',
    WITHDRAWAL = 'WITHDRAWAL',
}

export enum DepositStatus {
    AUTO_REFUNDED_3RD_PERSON_METHOD = 'auto-refunded-3rd-person-method',
    AUTO_REFUNDED_NAME_MISMATCH = 'auto-refunded-name-mismatch',
    CANCELLED = 'cancelled',
    COMPLETED = 'completed',
    FAILED = 'failed',
    PENDING = 'pending',
}

export const QUICK_DEPOSIT_REDIRECT_STATUS = 'quick-deposit-redirect';

export enum PayoutStatus {
    FAILED = 'failed',
    PAYOUT_FAILED = 'payout_failed',
    PENDING = 'pending',
}

export type ExistingPaymentMethod = {
    id: string;
    number: string;
    expirationDate?: string;
    description: string;
    extra?: Record<string, any>;
};

export type PnpSettings = {
    country: Country;
    isBonusAllowed: boolean;
    status: PnpStatus;
    provider: PROVIDERS;
    minAmount: Record<Currency, number>;
    maxAmount: Record<Currency, number>;
};

type PnpStatus = 'disabled' | 'office' | 'enabled';

export interface ProviderRouting {
    id: number;
    market: string;
    configs: ProviderRoutingConfig[];
    type: PROVIDER_TYPE;
}

interface ProviderRoutingConfig {
    conditions: ProviderRoutingCondition[];
    destinationProviderId: number;
}

interface ProviderRoutingCondition {
    field: string;
    operator: string;
    value: string | number | boolean;
}

export interface DepositWagering {
    hasDepositsTurnedOver: boolean;
    amount: number;
    turnover: number;
}
